import { CAlert, CButton, CContainer, CImg, CInputGroupText, CLabel, CRow, CSwitch } from '@coreui/react';
import classnames from 'classnames';
import * as React from 'react';
import { Redirect } from 'react-router';
import { TabContent, TabPane } from 'reactstrap';
import { ICultureInfo, ILocalizedLabels, ISaveConfigModel } from '../../abstraction';
import { KLoadingPanel, KSoundPlayer, NavMenu } from '../../components/';
import { AppLabels } from '../../core/AppLabels';
import { dispatcher, resourceManager, securitySvc, soundSvc } from '../../Karma';
import './Admin.css';
import { KLoginConfTabPanel } from './KLoginConfTabPanel';


interface IProps {
}

interface IState {
	activeTab: string;
	redirectUrl: string;
	saving: boolean;
	loading: boolean;
	showAppVersion: boolean;
	showX3Folder: boolean;
	cultures: ICultureInfo[];
	isDirty: boolean;
	statusMessage: string;
}

export class AdminView extends React.Component<IProps, IState> {
	public static URL = "/admin";

	public constructor(props: any) {
		super(props);

		this.state = {
			showAppVersion: false,
			showX3Folder: false,
			cultures: [],
			activeTab: "",
			redirectUrl: "",
			saving: false,
			loading: true,
			isDirty: false,
			statusMessage: "",
		}
		this.loadConfig();
	}

	loadConfig = async () => {
		dispatcher.getAdminViewModel().then((result) => {
			this.setState({
				loading: false,
				showAppVersion: result.showVersion,
				showX3Folder: result.showFolder,
				cultures: result.cultures,
			})
			this.forceUpdate();
		});
	}

	saveConfig = async () => {
		// On vérifie qu'au moins 1 langue est sélectionnée
		if (this.state.cultures.filter(x => x.active == true)[0] == undefined) {

			dispatcher.MessageBox(AppLabels.noActiveLangError, AppLabels.errorTitle, 3)
			return;
		}

		// Lancement de la sauvegarde
		this.setState({ saving: true })

		let labels: ILocalizedLabels[] = [];

		this.state.cultures.map(c => {
			labels.push({
				active: c.active,
				code: c.code,
				labels: c.labels
			})
		})

		let data: ISaveConfigModel = {
			showAppVersion: this.state.showAppVersion,
			showX3Folder: this.state.showX3Folder,
			localizedLabels: labels,
		}

		try {
			let result = await dispatcher.saveConfig(data);

			if (result == false) {
				dispatcher.MessageBox("", AppLabels.saveConfigError, 3);
			}
			else {
				this.setState({
					statusMessage: AppLabels.saveConfigOk
				});
			}
		}
		catch (err) {
			dispatcher.MessageBox("", err.toString(), 1);
			console.error(err);
		}

		this.setState({ saving: false })
	}


	//#region Gestion TAB
	toggle = (tab) => {
		if (this.state.activeTab !== tab) {
			this.setState({ activeTab: tab });
		}
	}
	//#endregion 

	showFolderChange = () => {
		let val = !this.state.showX3Folder;
		this.setState({ showX3Folder: val, isDirty: true });
	}

	showVersionChange = () => {
		let val = !this.state.showAppVersion;
		this.setState({ showAppVersion: val, isDirty: true });
	}

	onLangChange = (elem: ICultureInfo) => {
		this.setState({ isDirty: true });
		this.forceUpdate();
	}

	renderSaveStatus = () => {
		if (this.state.statusMessage) {
			return <CAlert color="success" closeButton >{this.state.statusMessage}</CAlert>
		}
		return "";
	}

	render() {
		if (!securitySvc.isAuth()) return <Redirect to="/"></Redirect>
		if (this.state.redirectUrl) return <Redirect to={this.state.redirectUrl} ></Redirect>
		if (this.state.loading) return <KLoadingPanel></KLoadingPanel>

		let submitState: boolean = !this.state.isDirty;

		var tab = (this.state.activeTab == "") ? this.state.cultures[0].code : this.state.activeTab;
		let conf = this.state.cultures;
		let InfoPanel = this.renderSaveStatus();

		return (
			<div>
				<NavMenu securityService={securitySvc} userFullName={securitySvc.currentUser.fullname} />

				<div className="Admin">
					<div className="KBreadcrum "><span>{AppLabels.viewAdminTitle}</span></div>

					<CContainer>
						<h3><CLabel>{AppLabels.configLoginLabelsTitle}</CLabel> </h3>

						<div className="TabMenu" >
							<CRow className="TabPanelHeader">
								{
									conf.map((x, i) =>
										<div key={i} className={classnames({ active: tab === x.code })} onClick={() => this.toggle(x.code)}>
											<CImg src={x.imgdata}></CImg>
											{x.code}
										</div>
									)
								}
							</CRow>
							<CRow>
								<TabContent activeTab={tab}>
									{
										conf.map((x, i) =>
											<TabPane key={i} tabId={x.code}>
												<KLoginConfTabPanel onChange={this.onLangChange} culture={x} key={i}></KLoginConfTabPanel>
											</TabPane>
										)
									}
								</TabContent>
							</CRow>
						</div>
					</CContainer>
					<CContainer>
						<CInputGroupText >
							<CSwitch id="showFolder" onChange={this.showFolderChange} checked={this.state.showX3Folder} type='switch' label={AppLabels.configShowX3} />
						</CInputGroupText>
						<CInputGroupText >
							<CSwitch id="showVersion" onChange={this.showVersionChange} checked={this.state.showAppVersion} type='switch' label={AppLabels.configShowVersion} />
						</CInputGroupText>
					</CContainer>

					<CContainer>
						{InfoPanel}
						<CButton disabled={submitState} size="sm" color="success" role="button" onClick={this.saveConfig}>{AppLabels.submit}</CButton>
					</CContainer>
					<hr />
					<CContainer>
						<h3><CLabel>{AppLabels.configSoundPlayTitle}</CLabel> </h3>
						{
							soundSvc.soundBank.map((x, i) =>
								<KSoundPlayer key={i} code={x.code} player={soundSvc}></KSoundPlayer>
							)
						}
					</CContainer >
					<hr />
					<CContainer className="grid">
						<h3><CLabel>{AppLabels.configIconsTitle}</CLabel> </h3>
						{
							resourceManager.imgBank.map((x, i) =>
								<div key={i} className='icone' >
									<CImg src={x.data} /><br />
									{x.code}
								</div>
							)
						}
					</CContainer>
				</div>
			</div>
		)
	}
}